import { PlanCheckoutKeys } from '../../../../consts';
import { useGetOnetimeExpectPlanPrice } from '../../../../services';
import { PlanProduct } from '../../../../types';

interface UseExpectedOnetimePlanPriceParams {
  spacePlanHashId?: string;
  selectedPlanInfo: PlanProduct;
  enabled: boolean;
}

interface ExpectedOnetimePlanPriceResult {
  미사용금액: number;
  추가결제예상금액: number;
  unusedDayCount: number;
  originalPrice: number;
  vatAmount: number;
}

/**
 * 일시납 플랜의 추가결제 예상금액을 계산합니다.
 * 미사용 금액은 서버의 VAT 적용 전 차감 금액을 그대로 사용합니다.
 * @param spacePlanHashId
 * @param selectedPlanInfo
 * @param isUpdate
 */
export const useExpectedOnetimePlanPrice = ({
  spacePlanHashId,
  selectedPlanInfo,
  enabled,
}: UseExpectedOnetimePlanPriceParams): ExpectedOnetimePlanPriceResult => {
  const { data: expectedPriceRes } = useGetOnetimeExpectPlanPrice(
    selectedPlanInfo?.id ?? 0,
    spacePlanHashId,
    {
      enabled: enabled && !!spacePlanHashId,
      queryKey: [
        ...PlanCheckoutKeys.ExpectedOnetimePrice(
          spacePlanHashId ?? '',
          selectedPlanInfo.id,
        ),
      ],
      placeholderData: () => {
        return {
          data: {
            isUpgrade: false,
            asisPlanId: 0,
            spacePlanTemplateId: selectedPlanInfo.id,
            saleType: selectedPlanInfo.saleType ?? '',
            salePrice: 0,
            unusedPrice: 0,
            unusedDayCount: 0,
            saleDiscountPrice: selectedPlanInfo.saleDiscountPrice,
            totalDiscountPrice: selectedPlanInfo.saleDiscountPrice,
            finalPrice: selectedPlanInfo.saleType
              ? selectedPlanInfo.salePrice
              : selectedPlanInfo.originalPrice,
            originalPrice: selectedPlanInfo.originalPrice,
            vatAmount: 0,
            vatRate: 0,
            priceBeforeVat: 0,
          },
          status: 0,
        };
      },
    },
  );

  const {
    finalPrice: 추가결제예상금액,
    unusedPrice: 미사용금액,
    unusedDayCount,
    originalPrice,
    vatAmount,
  } = expectedPriceRes.data;

  return {
    미사용금액,
    추가결제예상금액,
    unusedDayCount,
    originalPrice,
    vatAmount,
  };
};
